import React from 'react';
import DelayedLoading from '@/components/ui/DelayedLoading';
import LoadingStatus from '@/components/ui/LoadingStatus';

const LoadingState: React.FC = () => {
  return (
    <DelayedLoading loading>
      <LoadingStatus label="Loading matches" />
    </DelayedLoading>
  );
};

export default LoadingState;
